// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e45c01b","316":"fcfa80c8","455":"2872c904","762":"8dd7fdf4","977":"26fd5cca"}[chunkId] + ".chunk.js";
};